/* BENUTE Studio — sacola, compra rápida e medidas. Sem credenciais no tema. */
(() => {
  'use strict';
  if (window.BenuteStudio) return;
  window.BenuteStudio = true;
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lastOpener;
  function open(dialog, opener) {
    if (!dialog?.showModal) return false;
    lastOpener = opener || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('bn-modal-open');
    return true;
  }
  function close(dialog) { dialog?.close(); }
  function bindDialogs(scope = document) {
    $$('dialog.bn-modal, dialog.bn-drawer', scope).forEach(dialog => {
      if (dialog.dataset.bnBound) return;
      dialog.dataset.bnBound = 'true';
      dialog.addEventListener('click', e => { if (e.target === dialog || e.target.closest('[data-bn-close-dialog]')) close(dialog); });
      dialog.addEventListener('close', () => {
        if (!$('dialog[open]')) document.documentElement.classList.remove('bn-modal-open');
        lastOpener?.focus?.({ preventScroll: true });
      });
    });
  }
  const cart = $('[data-bn-cart]');
  const rootPath = window.Shopify?.routes?.root || cart?.dataset.bnRoot || '/';
  const base = rootPath.endsWith('/') ? rootPath : rootPath + '/';
  const cartURL = cart?.dataset.bnCartUrl || base + 'cart';
  let busy = false, revision = 0;
  const cartStatus = message => { if (cart) $('[data-bn-cart-status]', cart).textContent = message; };
  function markBusy(value) {
    busy = value;
    if (!cart) return;
    cart.setAttribute('aria-busy', String(value));
    $$('[data-bn-cart-quantity], button[name=checkout]', cart).forEach(b => b.disabled = value);
  }
  function renderCart(sections) {
    const html = sections?.['benute-cart-content'];
    if (typeof html !== 'string' || !html.includes('data-bn-cart-state')) throw new Error('Não foi possível atualizar a sacola. Abra a página da sacola para conferir.');
    $('[data-bn-cart-content]', cart).innerHTML = html;
    const count = $('[data-bn-cart-state]', cart).dataset.count;
    $('[data-bn-cart-count]', cart).textContent = `(${count})`;
    $$('.header__cart-count').forEach(node => node.textContent = count);
  }
  async function refreshCart() {
    const current = ++revision;
    const url = new URL(cartURL, location.origin);
    url.searchParams.set('sections', 'benute-cart-content');
    const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Não foi possível carregar a sacola. Tente novamente.');
    const sections = await response.json();
    if (current === revision) renderCart(sections);
  }
  async function openCart(opener) {
    if (!open(cart, opener)) { location.assign(cartURL); return; }
    if (busy) return;
    cartStatus('Carregando sua sacola…');
    try { await refreshCart(); cartStatus(''); } catch (error) { cartStatus(error.message); }
  }
  async function addToCart(data, opener) {
    if (busy) throw new Error('Aguarde a atualização da sacola.');
    markBusy(true); ++revision;
    let confirmed = false;
    try {
      const body = data instanceof FormData ? data : JSON.stringify({ ...data, sections: ['benute-cart-content'], sections_url: cartURL });
      if (data instanceof FormData) { data.set('sections', 'benute-cart-content'); data.set('sections_url', cartURL); }
      const response = await fetch(base + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', ...(data instanceof FormData ? {} : { 'Content-Type': 'application/json' }) }, body });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Confira a disponibilidade desta peça.');
      confirmed = true;
      close($('#BN-Quick'));
      if (!open(cart, opener)) { location.assign(cartURL); return result; }
      try { renderCart(result.sections); cartStatus('Peça adicionada à sacola.'); }
      catch (_) { try { await refreshCart(); cartStatus('Peça adicionada à sacola.'); } catch (_) { cartStatus('Peça adicionada. Abra a página da sacola para conferir.'); } }
      document.dispatchEvent(new CustomEvent('benute:cart-updated'));
      return result;
    } catch (error) {
      if (!confirmed && error instanceof TypeError) throw new Error('Não foi possível confirmar o envio. Confira a sacola antes de tentar novamente.');
      throw error;
    } finally { markBusy(false); }
  }
  if (cart) {
    window.BenuteCart = { open: openCart, add: addToCart };
    cart.addEventListener('click', async event => {
      const button = event.target.closest('[data-bn-cart-quantity]');
      if (!button || busy) return;
      const line = button.closest('[data-bn-line-key]');
      const quantity = Number(button.dataset.bnCartQuantity);
      if (!line || !Number.isInteger(quantity) || quantity < 0) return;
      const key = line.dataset.bnLineKey;
      const focusKind = quantity === 0 ? null : button.textContent.trim();
      markBusy(true); ++revision; cartStatus('Atualizando…');
      try {
        const response = await fetch(base + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: ['benute-cart-content'], sections_url: cartURL }) });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Não foi possível alterar a quantidade.');
        renderCart(result.sections); cartStatus('Sacola atualizada.');
        const updated = $$('[data-bn-line-key]', cart).find(el => el.dataset.bnLineKey === key);
        const focus = updated && $$('button', updated).find(b => b.textContent.trim() === focusKind);
        markBusy(false);
        (focus || $('[data-bn-close-dialog]', cart))?.focus({ preventScroll: true });
      } catch (error) { cartStatus(error.message || 'Confira sua sacola antes de tentar novamente.'); }
      finally { markBusy(false); }
    });
    // Prevent the legacy header's mini-cart from opening alongside the drawer.
    document.addEventListener('cart:refresh', event => { if(window.theme?.pageType !== 'cart') { event.stopImmediatePropagation(); if(!busy) refreshCart().catch(()=>{}); } }, true);
    document.addEventListener('product:added', event => { event.stopImmediatePropagation(); openCart(event.target); }, true);
  }
  function showMeasureTab(dialog, tab) {
    $$('[data-bn-measure-tab]', dialog).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.bnMeasureTab === tab)));
    $$('[data-bn-measure-panel]', dialog).forEach(p => p.hidden = p.dataset.bnMeasurePanel !== tab);
  }
  function calculateSize(dialog) {
    const result = $('[data-bn-measure-result]', dialog);
    const field = $('[data-bn-measure-input]', dialog);
    const value = Number(field.value);
    if (!field.value || !field.reportValidity() || !Number.isFinite(value) || value <= 0) { result.textContent = 'Informe uma medida válida em centímetros.'; return; }
    let config; try { config = JSON.parse($('[data-bn-size-data]', dialog).textContent); } catch (_) { result.textContent = 'Consulte a tabela de medidas.'; return; }
    const rows = (config.linhas || []).map(row => ({ size: row.tamanho, value: Number(row[config.medida]) })).filter(row => row.size && Number.isFinite(row.value) && row.value > 0).sort((a,b) => a.value-b.value);
    if (!rows.length || value < rows[0].value - 2 || value > rows[rows.length - 1].value + 2) { result.textContent = 'Sua medida está fora da faixa desta tabela. Confira o guia completo antes de escolher.'; return; }
    const closest = rows.reduce((best,row) => Math.abs(row.value-value) < Math.abs(best.value-value) ? row : best);
    result.textContent = `A medida mais próxima é a do tamanho ${closest.size}: ${closest.value} cm. Compare também comprimento e demais medidas antes de escolher. A disponibilidade aparece no seletor do produto.`;
  }
  let quickSequence = 0;
  async function quickShop(button) {
    const dialog = $('#BN-Quick');
    if (!open(dialog, button)) { location.assign(button.dataset.bnQuickUrl); return; }
    const sequence = ++quickSequence;
    const status = $('[data-bn-quick-status]', dialog), content = $('[data-bn-quick-content]', dialog);
    status.textContent = 'Carregando opções…'; content.replaceChildren();
    try {
      const url = new URL(button.dataset.bnQuickUrl, location.origin);
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Abra a página do produto para escolher suas opções.');
      const product = await response.json();
      if (sequence !== quickSequence || !dialog.open) return;
      status.textContent = '';
      const image = document.createElement('img'); image.className = 'bn-quick-image'; image.alt = product.title; image.width = 360; image.height = 480;
      const info = document.createElement('div'); info.className = 'bn-quick-info';
      const title = document.createElement('h3'); title.textContent = product.title;
      const price = document.createElement('p'); price.className = 'bn-quick-price';
      const form = document.createElement('form');
      const label = document.createElement('label'); label.textContent = 'Cor / tamanho'; label.htmlFor = 'BN-QuickVariant';
      const select = document.createElement('select'); select.id = 'BN-QuickVariant'; select.name = 'id';
      (product.variants || []).forEach(v => { const option = new Option(v.title + (v.available ? '' : ' — Esgotado'), String(v.id)); option.disabled = !v.available; select.add(option); });
      const available = product.variants.find(v => v.available); if (available) select.value = String(available.id);
      const submit = document.createElement('button'); submit.type = 'submit'; submit.className = 'bn-button bn-button--dark bn-button--full'; submit.textContent = 'Adicionar à sacola'; submit.disabled = !available;
      const link = document.createElement('a'); link.href = button.dataset.bnQuickUrl; link.className = 'bn-text-link'; link.textContent = 'Ver fotos, medidas e detalhes →';
      const sync = () => { const variant = product.variants.find(v => String(v.id) === select.value); if (!variant) return; price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: window.Shopify?.currency?.active || 'BRL' }).format(variant.price/100); const src = variant.featured_image?.src || product.featured_image; image.hidden = !src; if (src) image.src = src; submit.disabled = !variant.available; };
      select.addEventListener('change', sync); sync();
      form.append(label,select,submit); info.append(title,price,form,link); content.append(image,info);
      form.addEventListener('submit', async e => { e.preventDefault(); submit.disabled = true; status.textContent = 'Adicionando…'; try { await addToCart({ items: [{ id: Number(select.value), quantity: 1 }] }, button); } catch(error) { status.textContent = error.message; } finally { submit.disabled = !available; } });
    } catch (error) { if(sequence !== quickSequence) return; status.textContent = error.message; const link=document.createElement('a');link.href=button.dataset.bnQuickUrl;link.textContent='Abrir produto →';content.append(link); }
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-bn-dialog-open]');
    if (opener) { event.preventDefault(); const dialog = document.getElementById(opener.dataset.bnDialogOpen); if(dialog) { showMeasureTab(dialog,opener.dataset.bnSizeTab || 'table');open(dialog,opener); } }
    const tab = event.target.closest('[data-bn-measure-tab]'); if(tab) showMeasureTab(tab.closest('dialog'),tab.dataset.bnMeasureTab);
    const calculate = event.target.closest('[data-bn-measure-calculate]'); if(calculate) calculateSize(calculate.closest('dialog'));
    const cartOpener = event.target.closest('[data-bn-open-cart]'); if(cartOpener && cart) { event.preventDefault();openCart(cartOpener); }
    const quick = event.target.closest('[data-bn-quick-url]'); if(quick) quickShop(quick);
  });
  function init(scope=document) {
    bindDialogs(scope);
    $$('[data-bn-edits]', scope).forEach(section => {
      if (section.dataset.bnReady) return;
      section.dataset.bnReady='true';
      const tabs=$$('[data-bn-edit-tab]', section);
      const select=tab=>{ tabs.forEach(b=>b.setAttribute('aria-pressed',String(b===tab))); $$('[data-bn-edit-panel]',section).forEach(panel=>panel.hidden=panel.id!==tab.dataset.bnEditTab); };
      tabs.forEach(tab=>tab.addEventListener('click',()=>select(tab))); if(tabs[0]) select(tabs[0]);
    });
    $$('[data-bn-quick-url]',scope).forEach(b=>b.hidden=false);
    $$('.bn-grid',scope).forEach(grid=>{grid.dataset.bnItems=grid.children.length;});
  }
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
